// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SubMenuItem{\n  border-color:transparent;\n  --tw-text-opacity:1;\n  color:rgba(98, 106, 124, var(--tw-text-opacity))\n}\n.SubMenuItem.active{\n  --tw-border-opacity:1;\n  border-color:rgba(184, 27, 54, var(--tw-border-opacity));\n  --tw-text-opacity:1;\n  color:rgba(31, 42, 68, var(--tw-text-opacity))\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
